<template>
    <div v-if="!state.loading">
        <div class="pgehd">
            <h2>{{state.title}}</h2>
            <div class="pgectr">
                <span class="pgebtn" @click="createnew">
                    Add Questions
                </span>
            </div>
        </div>
        
        <PrimeDataTable
            :value="list"
            :rows="10"
            responsiveLayout="scroll"
            class="table"
            stripedRows>
            
            <PrimeColumn field="sn" header="sn" />
            <PrimeColumn field="question" header="Question">
                <template #body="slotProps">
                    <div v-html="slotProps.data.question"></div>
                </template>
            </PrimeColumn>
            <PrimeColumn field="options" header="Options" />
        </PrimeDataTable>
    </div>
    <div v-else class="loader">
        <img src="@/assets/img/ajldr.gif" />
    </div>

    <ModalView
        :isVisible="state.createModal"
        :fixclose="true"
        @close="state.createModal = false">
        <div class="qwrap" v-for="(row, rowIndex) in formField" :key="rowIndex">
            <span style="margin:15px 0px 5px; display:block">Question {{ row.label }}</span>
            <EditorView v-model="qcontent[row.name]" />
        </div>

        <div v-if="!state.success">
            <div v-if="!state.submitting" class="btnwrap">
                <button @click="addMore" class="btn-secondary">Add Question</button>
                <button class="btn-primary" @click="addQuestion">Submit</button>
            </div>
            <div style="text-align:center" v-else>
                <img src="@/assets/img/ajldr.gif" width="90px"/>
            </div>
        </div>
        <div v-else>
            <p style="background:green; color:white; margin:10px auto; width:80%">Questions Successfully Added</p>
        </div>

    </ModalView>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref, computed} from 'vue';
import { useRoute } from "vue-router";
import ModalView from "@/components/ModalView.vue";
import EditorView from '@/components/EditorView.vue'

export default {
    name:"AssignmentView",
    components:{ModalView,EditorView},
    setup(){
        const qcontent=ref({})
        const formField=ref([
        {label:"1", name: "Q1"}
        ])
        const content=ref()
        const route = useRoute();
        const id = computed(() => route.params.id);
        const state=reactive({loading:true, createModal:false, title:"Questions",
            submitting:false,error:[],success:false})
        const list = ref([])
        const globalFilter=ref("");

        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }

        onMounted(() => {
            call({
                url:urls.subject,
                data:{getAssignmentQuestions:id.value},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        state.title="Questions for "+res.msg.title
                        setTable(res.msg.list)
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function createnew(){
            if(!state.success && !state.submitting){
                formField.value=[
                    {label:"1", name: "Q1"}
                ]
                qcontent.value["Q1"]="";
            }
            state.createModal=true;
            state.submitting=false;
            state.errors=[];
            state.success=false;
        }

        function addQuestion(){
            var data={
                question:{ ...qcontent.value},
                addAssignmentQuestion:id.value,
                length:formField.value.length
            }
            state.submitting=true;
            state.errors=[];
            state.success=false;
            call({
                url:urls.subject,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        setTable(res.msg)
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }

        function addMore(){
            var num=formField.value.length+1;
            formField.value.push({
                label:num, name:"Q"+num
            })
        }
        
        return {list,globalFilter, state,content,qcontent,formField,addMore,
            createnew,addQuestion
        } 
    }
}
</script>
<style lang="css" scoped>
.btnwrap{display:flex; gap:10px}
:deep(.p-datatable-table img){max-width:200px !important}
</style>